import 'react-app-polyfill/stable';
import 'proxy-polyfill';
import 'core-js/proposals/promise-with-resolvers';

import React from 'react';
// import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';

import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/lib/integration/react'

import 'react-loading-skeleton/dist/skeleton.css'
import '~/assets/css/index.scss';

// import './assets/fonts';

import HttpsRedirect from 'react-https-redirect';
import App from '~/App';

import { getStore } from '~/store/store';

import dayjs from "dayjs";
import UTC from 'dayjs/plugin/utc';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(UTC);
dayjs.extend(isoWeek);
dayjs.extend(timezone);

// Chart.js registration
import { ArcElement, BarController, BarElement, CategoryScale, Chart as ChartJS, DoughnutController, Legend, LinearScale, Tooltip } from 'chart.js';
ChartJS.register(BarController, BarElement, CategoryScale, LinearScale, DoughnutController, ArcElement, Legend, Tooltip)

let {store, persistor} = getStore();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <HttpsRedirect>
                <App/>
            </HttpsRedirect>
        </PersistGate>
    </Provider>
);